import { Capacitor } from '@capacitor/core';

let HapticsPlugin = null;

// Lazy-load the Haptics plugin
const getHaptics = async () => {
  if (HapticsPlugin) return HapticsPlugin;
  if (Capacitor.isNativePlatform()) {
    const { Haptics } = await import('@capacitor/haptics');
    HapticsPlugin = Haptics;
    return Haptics;
  }
  return null;
};

// Light tap — fighter selection, method pick
export const tapLight = async () => {
  try {
    const haptics = await getHaptics();
    if (haptics) {
      await haptics.impact({ style: 'light' });
    } else if (navigator.vibrate) {
      navigator.vibrate(10);
    }
  } catch (e) { /* silent */ }
};

// Medium tap — submit picks, lock in
export const tapMedium = async () => {
  try {
    const haptics = await getHaptics();
    if (haptics) {
      await haptics.impact({ style: 'medium' });
    } else if (navigator.vibrate) {
      navigator.vibrate(20);
    }
  } catch (e) { /* silent */ }
};

// Success — all picks submitted
export const tapSuccess = async () => {
  try {
    const haptics = await getHaptics();
    if (haptics) {
      await haptics.notification({ type: 'success' });
    } else if (navigator.vibrate) {
      navigator.vibrate([15, 50, 15]);
    }
  } catch (e) { /* silent */ }
};
